import { Typography } from "@material-ui/core";
import React from "react";
import { Redirect, Route } from "react-router-dom";
import { AuthContext } from "./AuthContextProvider";

export default function AuthRoute({ adminRoute, ...props }) {
  const authContext = React.useContext(AuthContext);
  if (authContext.isLoggedIn) {
    if (adminRoute && !authContext.isAdministrator) {
      return (
        <Typography variant="h2" align="center">
          You do not have access to this page
        </Typography>
      );
    }
    return <Route {...props}></Route>;
  }
  return <Redirect to={{ pathname: "/", state: { from: props.location } }} />;
}
